export default __webpack_public_path__ + "static/media/NoProduct2.0ade9148.png";